module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('blockquote', [_c('p', {
    staticClass: "noind",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "id": "epigraph"
    }
  }, [_c('i', [_vm._v("A little fire is quickly trodden out;")])]), _vm._v(" "), _c('p', {
    staticClass: "noind"
  }, [_c('i', [_vm._v("Which, being suffer’d, rivers cannot quench.")])])]), _vm._v(" "), _c('p', {
    staticClass: "poem4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_vm._v("—William Shakespeare,")]), _vm._v(" "), _c('p', {
    staticClass: "poem4",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('i', [_vm._v("Henry VI")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09f2d266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Book1/4-epigraph.vue
// module id = 84
// module chunks = 0